export const SET_CONFIG = 'SET_CONFIG';

interface Employee {
    id: string,
    name: string
}

export interface Action {
    type: string;
    state: any;
}

export const setConfig = (data: Employee): Action => ({
    type: SET_CONFIG,
    state: data,
});